const DEFAULT_MAX_RETRIES = 10;
const DEFAULT_RETRY_DELAY_MS = 1000;

type Options = {
  name: string;
  maxRetries?: number;
  retryDelayMs?: number;
};

const readyPromises = new Map<string, Promise<unknown>>();

export const createWaitForGlobal =
  <T>(getter: () => T | undefined | null, options: Options) =>
  () =>
    waitForGlobal(getter, options);

export const waitForGlobal = <T>(
  getter: () => T | undefined | null,
  {
    name,
    maxRetries = DEFAULT_MAX_RETRIES,
    retryDelayMs = DEFAULT_RETRY_DELAY_MS,
  }: Options
): Promise<T> => {
  const existing = readyPromises.get(name);
  if (existing) return existing as Promise<T>;

  const promise = new Promise<T>((resolve, reject) => {
    let attempt = 0;
    const tick = () => {
      const value = getter();
      if (value) {
        readyPromises.delete(name);
        resolve(value);
        return;
      }
      if (attempt >= maxRetries) {
        console.log(
          `[${name}] script not loaded after ${maxRetries} retries — skipping`
        );
        readyPromises.delete(name);
        reject(new Error(`${name} not available`));
        return;
      }

      attempt += 1;
      setTimeout(tick, retryDelayMs);
    };
    tick();
  });

  readyPromises.set(name, promise);
  return promise;
};
